import styled from 'styled-components'
import { colors } from 'Styled/variables'

export const StyledInput = styled.div`
  height: 110px;

  textarea.ant-input {
    border-radius: 8px;
    border: 1px solid ${colors.greyStroke};
    background: ${colors.white};
    padding: 13px;
    height: 100%;
    resize: none;
  }

  .ant-input:focus {
    border-color: ${colors.greyStroke};
    box-shadow: none;
  }

  .ant-input:active {
    border-color: ${colors.greyStroke};
  }

  .ant-input:hover {
    border-color: ${colors.greyStroke};
  }
`
